exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".uploader{text-align:center;position:relative}.uploader .button.btn-primary{color:#600;width:100%;height:150px;border-radius:3px;min-width:125px;padding:0;border:1px solid #600}.uploader .button.btn-primary i{font-size:5rem}.uploader .button.btn-primary .label{color:#600;font-weight:400}.uploader img.img-responsive{color:#fff;border-radius:50%}.uploader .image,.uploader img.img-responsive{width:100%;height:150px;min-width:125px;padding:0}.uploader .image{position:relative;background-color:transparent;border-radius:3px;background-size:contain;background-position:50%;background-repeat:no-repeat;margin:auto}.uploader .button.btn-danger{background-color:hsla(0,0%,6%,.34);position:absolute;top:0;right:0;color:#600;width:100%;height:150px;border-radius:.5rem;border-color:#9a2b85;font-size:30px;border:1px solid #600}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5c6f342e","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/front/components/Uploader.vue
// module id = CTm5
// module chunks = 1